import React, { useState } from 'react';
import { Button } from './Button';
export function BookingModule({
  price
}: {
  price: string;
}) {
  const [quantity, setQuantity] = useState(1);
  const priceValue = parseFloat(price.replace('€', '').replace(',', '.'));
  const totalPrice = (priceValue * quantity).toFixed(2).replace('.', ',');
  return <div className="border border-gray-300 rounded-lg p-6 bg-gray-50" data-id="element-54">
      <h3 className="text-xl font-bold mb-4" data-id="element-55">Reserveren</h3>
      <div className="mb-5" data-id="element-56">
        <div className="flex justify-between mb-2" data-id="element-57">
          <span data-id="element-58">Prijs per persoon</span>
          <span className="font-bold" data-id="element-59">{price}</span>
        </div>
        <div className="border-t border-gray-200 my-4" data-id="element-60"></div>
        <div className="mb-4" data-id="element-61">
          <label className="block mb-2 font-medium" data-id="element-62">Aantal personen</label>
          <div className="flex border border-gray-300 rounded-md w-32 overflow-hidden" data-id="element-63">
            <button className="px-3 py-2 border-r border-gray-300 hover:bg-gray-100 transition-colors duration-150 focus:outline-none focus:bg-gray-100" onClick={() => setQuantity(Math.max(1, quantity - 1))} aria-label="Verminder aantal" data-id="element-64">
              -
            </button>
            <input type="number" min="1" value={quantity} onChange={e => setQuantity(parseInt(e.target.value) || 1)} className="w-full text-center py-2 focus:outline-none" aria-label="Aantal personen" data-id="element-65" />
            <button className="px-3 py-2 border-l border-gray-300 hover:bg-gray-100 transition-colors duration-150 focus:outline-none focus:bg-gray-100" onClick={() => setQuantity(quantity + 1)} aria-label="Vermeerder aantal" data-id="element-66">
              +
            </button>
          </div>
        </div>
        <div className="border-t border-gray-200 my-4" data-id="element-67"></div>
        <div className="flex justify-between mb-4" data-id="element-68">
          <span className="font-bold" data-id="element-69">Totaal</span>
          <span className="font-bold" data-id="element-70">€{totalPrice}</span>
        </div>
      </div>
      <Button variant="primary" size="large" className="w-full mb-3" data-id="element-71">
        Nu boeken
      </Button>
      <p className="text-xs text-gray-500 text-center mt-2" data-id="element-72">
        Veilig betalen via iDeal, Creditcard of Bancontact
      </p>
    </div>;
}